import type { PassId } from './passes'

export interface Resort {
  id: string
  name: string
  state: string
  country: 'US' | 'CA'
  region: string
  lat: number
  lng: number
  /** Primary multi-pass affiliation for filtering (approximate). */
  pass: PassId | 'mixed'
}

export const RESORTS: Resort[] = [
  {
    "id": "vail",
    "name": "Vail",
    "state": "CO",
    "country": "US",
    "region": "Rockies",
    "lat": 39.6061,
    "lng": -106.355,
    "pass": "epic"
  },
  {
    "id": "beaver-creek",
    "name": "Beaver Creek",
    "state": "CO",
    "country": "US",
    "region": "Rockies",
    "lat": 39.6042,
    "lng": -106.5165,
    "pass": "epic"
  },
  {
    "id": "breckenridge",
    "name": "Breckenridge",
    "state": "CO",
    "country": "US",
    "region": "Rockies",
    "lat": 39.4817,
    "lng": -106.0384,
    "pass": "epic"
  },
  {
    "id": "keystone",
    "name": "Keystone",
    "state": "CO",
    "country": "US",
    "region": "Rockies",
    "lat": 39.6069,
    "lng": -105.9542,
    "pass": "epic"
  },
  {
    "id": "crested-butte",
    "name": "Crested Butte",
    "state": "CO",
    "country": "US",
    "region": "Rockies",
    "lat": 38.8997,
    "lng": -106.9658,
    "pass": "epic"
  },
  {
    "id": "telluride",
    "name": "Telluride",
    "state": "CO",
    "country": "US",
    "region": "Rockies",
    "lat": 37.9375,
    "lng": -107.8123,
    "pass": "epic"
  },
  {
    "id": "aspen-mountain",
    "name": "Aspen Mountain",
    "state": "CO",
    "country": "US",
    "region": "Rockies",
    "lat": 39.1861,
    "lng": -106.8175,
    "pass": "ikon"
  },
  {
    "id": "aspen-highlands",
    "name": "Aspen Highlands",
    "state": "CO",
    "country": "US",
    "region": "Rockies",
    "lat": 39.1822,
    "lng": -106.855,
    "pass": "ikon"
  },
  {
    "id": "buttermilk",
    "name": "Buttermilk",
    "state": "CO",
    "country": "US",
    "region": "Rockies",
    "lat": 39.2086,
    "lng": -106.8625,
    "pass": "ikon"
  },
  {
    "id": "snowmass",
    "name": "Snowmass",
    "state": "CO",
    "country": "US",
    "region": "Rockies",
    "lat": 39.2089,
    "lng": -106.9492,
    "pass": "ikon"
  },
  {
    "id": "steamboat",
    "name": "Steamboat",
    "state": "CO",
    "country": "US",
    "region": "Rockies",
    "lat": 40.4572,
    "lng": -106.8045,
    "pass": "ikon"
  },
  {
    "id": "winter-park",
    "name": "Winter Park",
    "state": "CO",
    "country": "US",
    "region": "Rockies",
    "lat": 39.8868,
    "lng": -105.7625,
    "pass": "ikon"
  },
  {
    "id": "copper-mountain",
    "name": "Copper Mountain",
    "state": "CO",
    "country": "US",
    "region": "Rockies",
    "lat": 39.5022,
    "lng": -106.1497,
    "pass": "ikon"
  },
  {
    "id": "arapahoe-basin",
    "name": "Arapahoe Basin",
    "state": "CO",
    "country": "US",
    "region": "Rockies",
    "lat": 39.6425,
    "lng": -105.8717,
    "pass": "ikon"
  },
  {
    "id": "eldora",
    "name": "Eldora",
    "state": "CO",
    "country": "US",
    "region": "Rockies",
    "lat": 39.9375,
    "lng": -105.5828,
    "pass": "indy"
  },
  {
    "id": "loveland",
    "name": "Loveland",
    "state": "CO",
    "country": "US",
    "region": "Rockies",
    "lat": 39.6803,
    "lng": -105.8975,
    "pass": "indy"
  },
  {
    "id": "monarch",
    "name": "Monarch Mountain",
    "state": "CO",
    "country": "US",
    "region": "Rockies",
    "lat": 38.5122,
    "lng": -106.3322,
    "pass": "indy"
  },
  {
    "id": "powderhorn",
    "name": "Powderhorn",
    "state": "CO",
    "country": "US",
    "region": "Rockies",
    "lat": 39.0694,
    "lng": -108.1506,
    "pass": "indy"
  },
  {
    "id": "purgatory",
    "name": "Purgatory",
    "state": "CO",
    "country": "US",
    "region": "Rockies",
    "lat": 37.6303,
    "lng": -107.8139,
    "pass": "indy"
  },
  {
    "id": "sunlight",
    "name": "Sunlight Mountain",
    "state": "CO",
    "country": "US",
    "region": "Rockies",
    "lat": 39.3997,
    "lng": -107.3392,
    "pass": "indy"
  },
  {
    "id": "park-city",
    "name": "Park City",
    "state": "UT",
    "country": "US",
    "region": "Rockies",
    "lat": 40.6514,
    "lng": -111.508,
    "pass": "epic"
  },
  {
    "id": "deer-valley",
    "name": "Deer Valley",
    "state": "UT",
    "country": "US",
    "region": "Rockies",
    "lat": 40.6374,
    "lng": -111.4783,
    "pass": "ikon"
  },
  {
    "id": "alta",
    "name": "Alta",
    "state": "UT",
    "country": "US",
    "region": "Rockies",
    "lat": 40.5883,
    "lng": -111.6378,
    "pass": "ikon"
  },
  {
    "id": "snowbird",
    "name": "Snowbird",
    "state": "UT",
    "country": "US",
    "region": "Rockies",
    "lat": 40.5631,
    "lng": -111.6556,
    "pass": "ikon"
  },
  {
    "id": "brighton",
    "name": "Brighton",
    "state": "UT",
    "country": "US",
    "region": "Rockies",
    "lat": 40.5983,
    "lng": -111.5831,
    "pass": "ikon"
  },
  {
    "id": "solitude",
    "name": "Solitude",
    "state": "UT",
    "country": "US",
    "region": "Rockies",
    "lat": 40.6199,
    "lng": -111.5919,
    "pass": "ikon"
  },
  {
    "id": "snowbasin",
    "name": "Snowbasin",
    "state": "UT",
    "country": "US",
    "region": "Rockies",
    "lat": 41.216,
    "lng": -111.8569,
    "pass": "ikon"
  },
  {
    "id": "powder-mountain",
    "name": "Powder Mountain",
    "state": "UT",
    "country": "US",
    "region": "Rockies",
    "lat": 41.3792,
    "lng": -111.7806,
    "pass": "indy"
  },
  {
    "id": "beaver-mountain",
    "name": "Beaver Mountain",
    "state": "UT",
    "country": "US",
    "region": "Rockies",
    "lat": 41.9681,
    "lng": -111.5444,
    "pass": "indy"
  },
  {
    "id": "brian-head",
    "name": "Brian Head",
    "state": "UT",
    "country": "US",
    "region": "Rockies",
    "lat": 37.7022,
    "lng": -112.8497,
    "pass": "indy"
  },
  {
    "id": "heavenly",
    "name": "Heavenly",
    "state": "CA",
    "country": "US",
    "region": "California",
    "lat": 38.9353,
    "lng": -119.94,
    "pass": "epic"
  },
  {
    "id": "northstar",
    "name": "Northstar California",
    "state": "CA",
    "country": "US",
    "region": "California",
    "lat": 39.2746,
    "lng": -120.1211,
    "pass": "epic"
  },
  {
    "id": "kirkwood",
    "name": "Kirkwood",
    "state": "CA",
    "country": "US",
    "region": "California",
    "lat": 38.6847,
    "lng": -120.065,
    "pass": "epic"
  },
  {
    "id": "mammoth",
    "name": "Mammoth Mountain",
    "state": "CA",
    "country": "US",
    "region": "California",
    "lat": 37.6308,
    "lng": -119.0326,
    "pass": "ikon"
  },
  {
    "id": "palisades",
    "name": "Palisades Tahoe",
    "state": "CA",
    "country": "US",
    "region": "California",
    "lat": 39.197,
    "lng": -120.2356,
    "pass": "ikon"
  },
  {
    "id": "june-mountain",
    "name": "June Mountain",
    "state": "CA",
    "country": "US",
    "region": "California",
    "lat": 37.765,
    "lng": -119.0906,
    "pass": "ikon"
  },
  {
    "id": "bear-mountain",
    "name": "Bear Mountain",
    "state": "CA",
    "country": "US",
    "region": "California",
    "lat": 34.2275,
    "lng": -116.8603,
    "pass": "ikon"
  },
  {
    "id": "snow-summit",
    "name": "Snow Summit",
    "state": "CA",
    "country": "US",
    "region": "California",
    "lat": 34.2364,
    "lng": -116.8892,
    "pass": "ikon"
  },
  {
    "id": "sugar-bowl",
    "name": "Sugar Bowl",
    "state": "CA",
    "country": "US",
    "region": "California",
    "lat": 39.3042,
    "lng": -120.3356,
    "pass": "indy"
  },
  {
    "id": "homewood",
    "name": "Homewood",
    "state": "CA",
    "country": "US",
    "region": "California",
    "lat": 39.0856,
    "lng": -120.1606,
    "pass": "indy"
  },
  {
    "id": "mt-rose",
    "name": "Mt. Rose",
    "state": "NV",
    "country": "US",
    "region": "California",
    "lat": 39.3794,
    "lng": -119.885,
    "pass": "indy"
  },
  {
    "id": "diamond-peak",
    "name": "Diamond Peak",
    "state": "NV",
    "country": "US",
    "region": "California",
    "lat": 39.2536,
    "lng": -119.9236,
    "pass": "indy"
  },
  {
    "id": "whistler",
    "name": "Whistler Blackcomb",
    "state": "BC",
    "country": "CA",
    "region": "Canada West",
    "lat": 50.1163,
    "lng": -122.9574,
    "pass": "epic"
  },
  {
    "id": "stevens-pass",
    "name": "Stevens Pass",
    "state": "WA",
    "country": "US",
    "region": "Pacific NW",
    "lat": 47.7448,
    "lng": -121.089,
    "pass": "epic"
  },
  {
    "id": "crystal-mountain",
    "name": "Crystal Mountain",
    "state": "WA",
    "country": "US",
    "region": "Pacific NW",
    "lat": 46.9282,
    "lng": -121.4749,
    "pass": "ikon"
  },
  {
    "id": "schweitzer",
    "name": "Schweitzer",
    "state": "ID",
    "country": "US",
    "region": "Pacific NW",
    "lat": 48.3675,
    "lng": -116.6225,
    "pass": "ikon"
  },
  {
    "id": "mt-bachelor",
    "name": "Mt. Bachelor",
    "state": "OR",
    "country": "US",
    "region": "Pacific NW",
    "lat": 43.9794,
    "lng": -121.6889,
    "pass": "ikon"
  },
  {
    "id": "mt-hood-meadows",
    "name": "Mt. Hood Meadows",
    "state": "OR",
    "country": "US",
    "region": "Pacific NW",
    "lat": 45.3317,
    "lng": -121.665,
    "pass": "indy"
  },
  {
    "id": "timberline",
    "name": "Timberline Lodge",
    "state": "OR",
    "country": "US",
    "region": "Pacific NW",
    "lat": 45.3311,
    "lng": -121.7111,
    "pass": "indy"
  },
  {
    "id": "mt-baker",
    "name": "Mt. Baker",
    "state": "WA",
    "country": "US",
    "region": "Pacific NW",
    "lat": 48.8575,
    "lng": -121.6669,
    "pass": "indy"
  },
  {
    "id": "49-degrees-north",
    "name": "49 Degrees North",
    "state": "WA",
    "country": "US",
    "region": "Pacific NW",
    "lat": 48.3011,
    "lng": -117.5628,
    "pass": "indy"
  },
  {
    "id": "red-mountain",
    "name": "Red Mountain",
    "state": "BC",
    "country": "CA",
    "region": "Canada West",
    "lat": 49.1042,
    "lng": -117.8461,
    "pass": "indy"
  },
  {
    "id": "fernie",
    "name": "Fernie Alpine",
    "state": "BC",
    "country": "CA",
    "region": "Canada West",
    "lat": 49.4625,
    "lng": -115.0869,
    "pass": "indy"
  },
  {
    "id": "sun-peaks",
    "name": "Sun Peaks",
    "state": "BC",
    "country": "CA",
    "region": "Canada West",
    "lat": 50.8836,
    "lng": -119.8944,
    "pass": "indy"
  },
  {
    "id": "big-white",
    "name": "Big White",
    "state": "BC",
    "country": "CA",
    "region": "Canada West",
    "lat": 49.7331,
    "lng": -118.1394,
    "pass": "indy"
  },
  {
    "id": "revelstoke",
    "name": "Revelstoke Mountain",
    "state": "BC",
    "country": "CA",
    "region": "Canada West",
    "lat": 50.9583,
    "lng": -118.1639,
    "pass": "indy"
  },
  {
    "id": "banff-sunshine",
    "name": "Sunshine Village",
    "state": "AB",
    "country": "CA",
    "region": "Canada West",
    "lat": 51.0783,
    "lng": -115.7619,
    "pass": "ikon"
  },
  {
    "id": "lake-louise",
    "name": "Lake Louise",
    "state": "AB",
    "country": "CA",
    "region": "Canada West",
    "lat": 51.4419,
    "lng": -116.1625,
    "pass": "ikon"
  },
  {
    "id": "norquay",
    "name": "Mt. Norquay",
    "state": "AB",
    "country": "CA",
    "region": "Canada West",
    "lat": 51.2044,
    "lng": -115.5986,
    "pass": "ikon"
  },
  {
    "id": "jackson-hole",
    "name": "Jackson Hole",
    "state": "WY",
    "country": "US",
    "region": "Rockies",
    "lat": 43.5875,
    "lng": -110.8275,
    "pass": "ikon"
  },
  {
    "id": "grand-targhee",
    "name": "Grand Targhee",
    "state": "WY",
    "country": "US",
    "region": "Rockies",
    "lat": 43.7914,
    "lng": -110.9586,
    "pass": "indy"
  },
  {
    "id": "big-sky",
    "name": "Big Sky",
    "state": "MT",
    "country": "US",
    "region": "Rockies",
    "lat": 45.2867,
    "lng": -111.4014,
    "pass": "ikon"
  },
  {
    "id": "bridger-bowl",
    "name": "Bridger Bowl",
    "state": "MT",
    "country": "US",
    "region": "Rockies",
    "lat": 45.8175,
    "lng": -110.8967,
    "pass": "indy"
  },
  {
    "id": "whitefish",
    "name": "Whitefish Mountain",
    "state": "MT",
    "country": "US",
    "region": "Rockies",
    "lat": 48.4806,
    "lng": -114.35,
    "pass": "indy"
  },
  {
    "id": "sun-valley",
    "name": "Sun Valley",
    "state": "ID",
    "country": "US",
    "region": "Rockies",
    "lat": 43.6856,
    "lng": -114.3514,
    "pass": "ikon"
  },
  {
    "id": "bogus-basin",
    "name": "Bogus Basin",
    "state": "ID",
    "country": "US",
    "region": "Rockies",
    "lat": 43.7642,
    "lng": -116.1033,
    "pass": "indy"
  },
  {
    "id": "taos",
    "name": "Taos Ski Valley",
    "state": "NM",
    "country": "US",
    "region": "Rockies",
    "lat": 36.5958,
    "lng": -105.4544,
    "pass": "ikon"
  },
  {
    "id": "santa-fe",
    "name": "Ski Santa Fe",
    "state": "NM",
    "country": "US",
    "region": "Rockies",
    "lat": 35.7964,
    "lng": -105.8022,
    "pass": "indy"
  },
  {
    "id": "ski-apache",
    "name": "Ski Apache",
    "state": "NM",
    "country": "US",
    "region": "Rockies",
    "lat": 33.3975,
    "lng": -105.7889,
    "pass": "indy"
  },
  {
    "id": "arizona-snowbowl",
    "name": "Arizona Snowbowl",
    "state": "AZ",
    "country": "US",
    "region": "Rockies",
    "lat": 35.3306,
    "lng": -111.7103,
    "pass": "indy"
  },
  {
    "id": "stowe",
    "name": "Stowe",
    "state": "VT",
    "country": "US",
    "region": "Northeast",
    "lat": 44.5303,
    "lng": -72.7814,
    "pass": "epic"
  },
  {
    "id": "okemo",
    "name": "Okemo",
    "state": "VT",
    "country": "US",
    "region": "Northeast",
    "lat": 43.4014,
    "lng": -72.7172,
    "pass": "epic"
  },
  {
    "id": "mount-snow",
    "name": "Mount Snow",
    "state": "VT",
    "country": "US",
    "region": "Northeast",
    "lat": 42.9578,
    "lng": -72.9206,
    "pass": "epic"
  },
  {
    "id": "hunter",
    "name": "Hunter Mountain",
    "state": "NY",
    "country": "US",
    "region": "Northeast",
    "lat": 42.2028,
    "lng": -74.2106,
    "pass": "epic"
  },
  {
    "id": "attitash",
    "name": "Attitash",
    "state": "NH",
    "country": "US",
    "region": "Northeast",
    "lat": 44.0828,
    "lng": -71.2294,
    "pass": "epic"
  },
  {
    "id": "wildcat",
    "name": "Wildcat Mountain",
    "state": "NH",
    "country": "US",
    "region": "Northeast",
    "lat": 44.2631,
    "lng": -71.2392,
    "pass": "epic"
  },
  {
    "id": "crotched",
    "name": "Crotched Mountain",
    "state": "NH",
    "country": "US",
    "region": "Northeast",
    "lat": 42.9983,
    "lng": -71.8739,
    "pass": "epic"
  },
  {
    "id": "liberty",
    "name": "Liberty Mountain",
    "state": "PA",
    "country": "US",
    "region": "Northeast",
    "lat": 39.7636,
    "lng": -77.3753,
    "pass": "epic"
  },
  {
    "id": "whitetail",
    "name": "Whitetail Resort",
    "state": "PA",
    "country": "US",
    "region": "Northeast",
    "lat": 39.7417,
    "lng": -77.9331,
    "pass": "epic"
  },
  {
    "id": "roundtop",
    "name": "Roundtop Mountain",
    "state": "PA",
    "country": "US",
    "region": "Northeast",
    "lat": 40.1061,
    "lng": -76.9267,
    "pass": "epic"
  },
  {
    "id": "jack-frost",
    "name": "Jack Frost",
    "state": "PA",
    "country": "US",
    "region": "Northeast",
    "lat": 41.1086,
    "lng": -75.6525,
    "pass": "epic"
  },
  {
    "id": "big-boulder",
    "name": "Big Boulder",
    "state": "PA",
    "country": "US",
    "region": "Northeast",
    "lat": 41.05,
    "lng": -75.6011,
    "pass": "epic"
  },
  {
    "id": "killington",
    "name": "Killington",
    "state": "VT",
    "country": "US",
    "region": "Northeast",
    "lat": 43.6045,
    "lng": -72.8201,
    "pass": "ikon"
  },
  {
    "id": "sugarbush",
    "name": "Sugarbush",
    "state": "VT",
    "country": "US",
    "region": "Northeast",
    "lat": 44.1364,
    "lng": -72.8944,
    "pass": "ikon"
  },
  {
    "id": "stratton",
    "name": "Stratton",
    "state": "VT",
    "country": "US",
    "region": "Northeast",
    "lat": 43.1133,
    "lng": -72.9081,
    "pass": "ikon"
  },
  {
    "id": "sunday-river",
    "name": "Sunday River",
    "state": "ME",
    "country": "US",
    "region": "Northeast",
    "lat": 44.4733,
    "lng": -70.8569,
    "pass": "ikon"
  },
  {
    "id": "sugarloaf",
    "name": "Sugarloaf",
    "state": "ME",
    "country": "US",
    "region": "Northeast",
    "lat": 45.0542,
    "lng": -70.3103,
    "pass": "ikon"
  },
  {
    "id": "loon",
    "name": "Loon Mountain",
    "state": "NH",
    "country": "US",
    "region": "Northeast",
    "lat": 44.0361,
    "lng": -71.6217,
    "pass": "ikon"
  },
  {
    "id": "snowshoe",
    "name": "Snowshoe",
    "state": "WV",
    "country": "US",
    "region": "Northeast",
    "lat": 38.4128,
    "lng": -79.9947,
    "pass": "ikon"
  },
  {
    "id": "windham",
    "name": "Windham Mountain",
    "state": "NY",
    "country": "US",
    "region": "Northeast",
    "lat": 42.2994,
    "lng": -74.2561,
    "pass": "indy"
  },
  {
    "id": "gore",
    "name": "Gore Mountain",
    "state": "NY",
    "country": "US",
    "region": "Northeast",
    "lat": 43.6725,
    "lng": -74.0069,
    "pass": "indy"
  },
  {
    "id": "whiteface",
    "name": "Whiteface Mountain",
    "state": "NY",
    "country": "US",
    "region": "Northeast",
    "lat": 44.3658,
    "lng": -73.9025,
    "pass": "indy"
  },
  {
    "id": "jay-peak",
    "name": "Jay Peak",
    "state": "VT",
    "country": "US",
    "region": "Northeast",
    "lat": 44.9283,
    "lng": -72.5047,
    "pass": "indy"
  },
  {
    "id": "smugglers-notch",
    "name": "Smugglers' Notch",
    "state": "VT",
    "country": "US",
    "region": "Northeast",
    "lat": 44.5725,
    "lng": -72.7761,
    "pass": "indy"
  },
  {
    "id": "mad-river-glen",
    "name": "Mad River Glen",
    "state": "VT",
    "country": "US",
    "region": "Northeast",
    "lat": 44.2025,
    "lng": -72.9175,
    "pass": "indy"
  },
  {
    "id": "cannon",
    "name": "Cannon Mountain",
    "state": "NH",
    "country": "US",
    "region": "Northeast",
    "lat": 44.1567,
    "lng": -71.6989,
    "pass": "indy"
  },
  {
    "id": "waterville-valley",
    "name": "Waterville Valley",
    "state": "NH",
    "country": "US",
    "region": "Northeast",
    "lat": 43.9653,
    "lng": -71.5278,
    "pass": "indy"
  },
  {
    "id": "bretton-woods",
    "name": "Bretton Woods",
    "state": "NH",
    "country": "US",
    "region": "Northeast",
    "lat": 44.2583,
    "lng": -71.4408,
    "pass": "indy"
  },
  {
    "id": "sugar",
    "name": "Sugar Mountain",
    "state": "NC",
    "country": "US",
    "region": "Southeast",
    "lat": 36.1336,
    "lng": -81.8667,
    "pass": "indy"
  },
  {
    "id": "beech",
    "name": "Beech Mountain",
    "state": "NC",
    "country": "US",
    "region": "Southeast",
    "lat": 36.1936,
    "lng": -81.8769,
    "pass": "indy"
  },
  {
    "id": "boyne-mountain",
    "name": "Boyne Mountain",
    "state": "MI",
    "country": "US",
    "region": "Midwest",
    "lat": 45.1625,
    "lng": -84.9256,
    "pass": "indy"
  },
  {
    "id": "boyne-highlands",
    "name": "Boyne Highlands",
    "state": "MI",
    "country": "US",
    "region": "Midwest",
    "lat": 45.4708,
    "lng": -84.9272,
    "pass": "indy"
  },
  {
    "id": "lutsen",
    "name": "Lutsen Mountains",
    "state": "MN",
    "country": "US",
    "region": "Midwest",
    "lat": 47.6639,
    "lng": -90.7139,
    "pass": "indy"
  },
  {
    "id": "spirit-mountain",
    "name": "Spirit Mountain",
    "state": "MN",
    "country": "US",
    "region": "Midwest",
    "lat": 46.7186,
    "lng": -92.2169,
    "pass": "indy"
  },
  {
    "id": "cascades",
    "name": "Cascade Mountain",
    "state": "WI",
    "country": "US",
    "region": "Midwest",
    "lat": 43.5042,
    "lng": -89.5194,
    "pass": "indy"
  },
  {
    "id": "alpine-valley-mi",
    "name": "Alpine Valley",
    "state": "MI",
    "country": "US",
    "region": "Midwest",
    "lat": 42.7389,
    "lng": -83.5042,
    "pass": "indy"
  },
  {
    "id": "perfect-north",
    "name": "Perfect North Slopes",
    "state": "IN",
    "country": "US",
    "region": "Midwest",
    "lat": 39.1461,
    "lng": -84.8856,
    "pass": "indy"
  },
  {
    "id": "snow-creek",
    "name": "Snow Creek",
    "state": "MO",
    "country": "US",
    "region": "Midwest",
    "lat": 39.4667,
    "lng": -94.9833,
    "pass": "indy"
  },
  {
    "id": "hidden-valley-mo",
    "name": "Hidden Valley",
    "state": "MO",
    "country": "US",
    "region": "Midwest",
    "lat": 38.5333,
    "lng": -90.65,
    "pass": "indy"
  },
  {
    "id": "paoli-peaks",
    "name": "Paoli Peaks",
    "state": "IN",
    "country": "US",
    "region": "Midwest",
    "lat": 38.5556,
    "lng": -86.6111,
    "pass": "indy"
  },
  {
    "id": "cataloochee",
    "name": "Cataloochee",
    "state": "NC",
    "country": "US",
    "region": "Southeast",
    "lat": 35.5631,
    "lng": -83.09,
    "pass": "indy"
  },
  {
    "id": "wintergreen",
    "name": "Wintergreen Resort",
    "state": "VA",
    "country": "US",
    "region": "Southeast",
    "lat": 37.9197,
    "lng": -78.9417,
    "pass": "indy"
  },
  {
    "id": "massanutten",
    "name": "Massanutten",
    "state": "VA",
    "country": "US",
    "region": "Southeast",
    "lat": 38.4083,
    "lng": -78.7514,
    "pass": "indy"
  },
  {
    "id": "canaan-valley",
    "name": "Canaan Valley",
    "state": "WV",
    "country": "US",
    "region": "Southeast",
    "lat": 39.0139,
    "lng": -79.3986,
    "pass": "indy"
  },
  {
    "id": "timberline-wv",
    "name": "Timberline WV",
    "state": "WV",
    "country": "US",
    "region": "Southeast",
    "lat": 39.045,
    "lng": -79.3986,
    "pass": "indy"
  },
  {
    "id": "blue-mountain-on",
    "name": "Blue Mountain",
    "state": "ON",
    "country": "CA",
    "region": "East Canada",
    "lat": 44.5025,
    "lng": -80.3139,
    "pass": "indy"
  },
  {
    "id": "tremblant",
    "name": "Mont Tremblant",
    "state": "QC",
    "country": "CA",
    "region": "East Canada",
    "lat": 46.2128,
    "lng": -74.5847,
    "pass": "indy"
  },
  {
    "id": "mont-sainte-anne",
    "name": "Mont Sainte-Anne",
    "state": "QC",
    "country": "CA",
    "region": "East Canada",
    "lat": 47.0756,
    "lng": -70.9067,
    "pass": "indy"
  },
  {
    "id": "le-massif",
    "name": "Le Massif",
    "state": "QC",
    "country": "CA",
    "region": "East Canada",
    "lat": 47.2786,
    "lng": -70.5997,
    "pass": "indy"
  },
  {
    "id": "mont-orford",
    "name": "Mont Orford",
    "state": "QC",
    "country": "CA",
    "region": "East Canada",
    "lat": 45.3139,
    "lng": -72.2417,
    "pass": "indy"
  }
]

export function resortById(id: string): Resort | undefined {
  return RESORTS.find((r) => r.id === id)
}

export const REGIONS = [...new Set(RESORTS.map((r) => r.region))].sort()
